import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n          overflow: hidden;\n          height: 93.75rem;\n          position: relative;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
var Container = /*#__PURE__*/ styled("div", {
    target: "ecz2xyw0"
})(function(param) {
    var isCollapsed = param.isCollapsed;
    return isCollapsed ? css(_templateObject()) : "";
});
var CollapsedOverlay = /*#__PURE__*/ styled("span", {
    target: "ecz2xyw1"
})("width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.spacing[110];
}, ";display:", function(param) {
    var isCollapsed = param.isCollapsed;
    return isCollapsed ? "inline-block" : "none";
}, ";bottom:0;position:absolute;background-image:", function(param) {
    var theme = param.theme;
    return "linear-gradient(0deg,".concat(theme.color.natural0, ", #0000)");
}, ";");
export { CollapsedOverlay, Container };
